import { generateDPIA } from '../../../engine/dpiaChecklist';

export function DPIAReport() {
  const res = generateDPIA({ modules: ['iot','registry','wallet'], dataFlows: ['meter->server'] });
  return (
    <div className="space-y-2 border border-evat-gold/40 rounded p-3 text-sm">
      <div className="font-orbitron text-evat-gold">DPIA Report</div>
      <ul className="list-disc ml-5">
        {res.items.map(i=> (<li key={i.id}><span className={i.status==='ok'?'text-emerald-400':'text-yellow-400'}>{i.desc}</span></li>))}
      </ul>
    </div>
  );
}

export default DPIAReport;



















